import React from "react";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

Modal.setAppElement("#root"); // Ensure accessibility

const StatusTypeModel = ({ isOpen, onClose, statusTypeSub, handleChange, handleSubmit,statusType }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      contentLabel="Expense Tracker Form"
      style={{
        overlay: {
          background: "rgba(0,0,0,0.6)",
          position: "fixed",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
        },
        content: {
          background: "linear-gradient(168deg, #c1e0ff 0%, #efdeff 100%)",
          position: "absolute",
          top: "40px",
          left: "30%",
          right: "30%",
          bottom: "40px",
          height: "50%",
          width: "40%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        },
      }}
    >
      <FontAwesomeIcon className="ExpenseTrackerFormCloseBtn" onClick={onClose} title="Close" icon={faClose} />
      <p className="ExpenseTrackerFormHeadLabel">{`${statusType?statusType.toUpperCase():"Add Status"}`}</p>
      <form className="ExpenseTrackerForm" onSubmit={handleSubmit}>
        <div className="ExpenseTrackerFormFeilds">
          <label className="ExpenseTrackerFormLabels">
            Status Subject<span>*</span>
          </label>
          <input
            placeholder="Subject"
            className="ExpenseTrackerFormInputs"
            required
            value={statusTypeSub.Status}
            onChange={handleChange}
            type="text"
            name="Status"
          />
        </div>
        <div className="ExpenseTrackerFormFeilds">
          <label className="ExpenseTrackerFormLabels">
            Subject Reason <span>*</span>
          </label>
          <input
            placeholder="Reason"
            required
            value={statusTypeSub.Status_Ref}
            onChange={handleChange}
            className="ExpenseTrackerFormInputs"
            name="Status_Ref"
          />
        </div>
        <div className="ExpenseTrackerFormFooter">
          <button className="ExpenseTrackerFormSubmitBtn" title="Confirm" type="submit">
            Confirm
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default StatusTypeModel;
